// src/lib/utils/image-utils.ts


/**
 * Converts an image URL to a Base64 Data URL using Fetch API and FileReader.
 * This function should only be called in a browser environment.
 * @param url The URL of the image (e.g., '/images/my-image.png').
 * @returns A Promise that resolves with the Base64 Data URL string, or null if an error occurs.
 */
export async function imageUrlToBase64(url) {


    console.log(`imageUrlToBase64: Attempting to fetch URL: ${url}`); // <-- NEW LOG

    try {
        const response = await fetch(url);
        console.log(`imageUrlToBase64: Fetch response status: ${response.status}, ok: ${response.ok}`); // <-- NEW LOG

        if (!response.ok) {
            // Log response details if not OK
            const errorDetails = `Status: ${response.status}, text: ${response.statusText}, type: ${response.type}`;
            console.error(`imageUrlToBase64: HTTP error! ${errorDetails} for URL: ${url}`); // <-- MORE DETAIL
            throw new Error(`imageUrlToBase64: HTTP error! ${errorDetails} for URL: ${url}`);
        }
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(new Error(`FileReader error: ${error.target?.error} for URL: ${url}`));
            };
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('imageUrlToBase64: Caught error during fetch or conversion:', error);
        return null;
    }
}